// Webpack Imports
import * as bootstrap from 'bootstrap';

( function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call( document.querySelectorAll( '.search-form' ), ( el ) => {
		el.addEventListener( 'submit', function ( e ) {
			var search = el.querySelector( 'input' );
			if ( search.value.length < 1 ) {
				e.preventDefault();
				search.focus();
			}
		} );
	} );

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="popover"]' ) );
	var popoverList = popoverTriggerList.map( function ( popoverTriggerEl ) {
		return new bootstrap.Popover( popoverTriggerEl, {
			trigger: 'focus',
		} );
	} );
} )();

$(function() {
	if($('#home-banner-logo') && $('#home-banner-logo').offset()) {
		$(function() {
			$('#home-banner-logo').css('width', 120 + (($('#home-banner-logo').offset().top - $(window).scrollTop()) / 4));
		});
		$(window).on('scroll',function() {
			$('#home-banner-logo').css('width', 120 + (($('#home-banner-logo').offset().top - $(window).scrollTop()) / 4));
			// $('#home-banner-logo').animate({ width: $('#home-banner-logo').offset().top }, 1);
			if ($('.home-menu-logo').offset().top > $('#home-banner-logo').offset().top) {
				$('.home-menu-logo').addClass('fadein')
				$('#header.home-menu').addClass('shrink');
			} else {
				$('.home-menu-logo').removeClass('fadein')
				$('#header.home-menu').removeClass('shrink');
			}
			if ($('.closed-logo').offset().top > $('#home-banner-logo').offset().top) {
				$('.closed-logo').addClass('fadein')
				$('#header.home-menu').addClass('shrink-mobile');
			} else {
				$('.closed-logo').removeClass('fadein')
				$('#header.home-menu').removeClass('shrink-mobile');
			}
		});
	}
});